import { State } from "../../client";

interface Props {
  state: State<string>;
  disabled?: boolean;
  placeholder?: string;
}

export function TextInput({
  state: [value, setValue],
  disabled,
  placeholder,
}: Props) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder ?? "Enter your answer..."}
      disabled={disabled}
    />
  );
}
